module.exports = __webpack_public_path__ + "img/no-o365.997f6af4.png";